<template>
    <div>
        <canvas id="main-scene"></canvas>
    </div>
</template>

<script>

    import * as THREE from 'three';
    import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
    import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
    import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';

    import './../script/raf_polify';


    let scene,
        renderer,
        controls,
        light,
        camera;
        
    let loaded = 0,
        gltfs = [
            'scene.glb',
            'weightlifting.glb'
        ],
        gltfLoader,
        dracoLoader;

    let mixer;
    let clock = new THREE.Clock();
    let timer = 0;

    export default {

        data() {
            return {
                baseUrl: process.env.VUE_APP_BASEURL,
            }
        },
        
        mounted () {
            this.scene_init();
        },

        methods: {
            
            scene_init() {
                
                /* 初始化場景 */
                const canvas = document.querySelector('#main-scene');

                renderer = new THREE.WebGLRenderer({
                    canvas: canvas,
                    antialias: true
                });

                renderer.powerPreference = 'high-performance';
                
                // renderer.toneMappingExposure = 0.36;
                
                /* if(mode == 'day') {
                    renderer.gammaFactor = 2.2;
                    renderer.toneMappingExposure = 0.43;
                }
                else {
                    renderer.gammaFactor = 2;
                    renderer.toneMappingExposure = 0.36;
                } */

                renderer.gammaFactor = 2.2;
                renderer.toneMappingExposure = 0.43;

                renderer.toneMapping = THREE.LinearToneMapping;
                renderer.gammaOutput = true;
                renderer.shadowMap.enabled = true;
                renderer.shadowMap.type = THREE.PCFSoftShadowMap;
                
                /* 
                限制最高解析度 2x
                3x解析度設備 (ex. iPhoneX 以上受影響)
                */
                let ratio = Math.min(2, window.devicePixelRatio);
                renderer.setPixelRatio( ratio );

                camera = new THREE.PerspectiveCamera(6, 1, 0.1, 1000);
                camera.position.set(-3668, 2881, 4143);
                // camera.layers.enable(1);
                // camera.layers.enable(2);
                // camera.layers.enable(3);

                controls = new OrbitControls(camera, canvas);

                scene = new THREE.Scene();
                scene.background = new THREE.Color('#333333');
                scene.add(camera);

                if (resizeRendererToDisplaySize(renderer)) {
                    const canvas = renderer.domElement;
                    camera.aspect = canvas.clientWidth / canvas.clientHeight;
                    camera.updateProjectionMatrix();
                }

                this.gltf_load_start();
            },

            gltf_load_start () {
                /* 開始載入gltf檔案 */
                dracoLoader = new DRACOLoader();
                dracoLoader.setDecoderPath( this.baseUrl + 'js/lib/draco/' );
                gltfLoader = new GLTFLoader();
                gltfLoader.setDRACOLoader( dracoLoader );
                this.gltf_load_control();
            },


            gltf_load_control () {

                gltfLoader.load( this.baseUrl + 'models/' + gltfs[loaded], (gltf) => {
                    // if(loaded == 0) this.$store.commit('loadingText', '初始化');
                    this.gltf_loaded(gltf);
                });
            },

            gltf_loaded (gltf) {

                loaded++;

                /* 將模型加入場景中 */

                scene.add(gltf.scene);
                gltf.scene.position.set(0, 0, 0);
                gltf.scene.updateMatrixWorld();
                gltf.scene.receiveShadow = true;

                gltf.scene.traverse((obj) => {

                    if(obj.castShadow != undefined) {
                        obj.castShadow = true;
                        obj.receiveShadow = true;
                    }

                    if(obj.name == 'Gymnastics_mat') {
                        obj.material.receiveShadow = true;
                    }

                    if(obj.material !== undefined) {
                        obj.material.metalness = 0.3;
                        obj.material.roughness = 2;
                        obj.material.needsUpdate = true; 
                    } 
                });

                if(loaded == 1) {
                    this.controls_init(gltf.scene);
                    gltf.scene.scale.set(1, 1, 1); 
                    
                }

                if(loaded == 2) {
                    
                    
                    this.gltf_get_animation(loaded, gltf);
                    
                    gltf.scene.position.set(0, -7.6, 0);
                    gltf.scene.scale.set(200, 200, 200);
                    // gltf.scene.position

                    /* const groundGeo = new THREE.PlaneGeometry( 10000, 10000 );
                    const groundMat = new THREE.MeshLambertMaterial( { color: 0x1938bc } );
                    groundMat.color.setHex(0x1938bc);

                    const ground = new THREE.Mesh( groundGeo, groundMat );
                    ground.position.y = 0;
                    ground.rotation.x = - Math.PI / 2;
                    ground.receiveShadow = true;
                    scene.add( ground ); */
                }

                if(loaded < gltfs.length) {

                    this.gltf_load_control();
                }
                else {
                    this.set_light();
                }
                
            },

            controls_init (root) {

                /* 主場景引入後，偵測範圍，調整攝影機 */
                const box = new THREE.Box3().setFromObject(root);
                const boxSize = box.getSize(new THREE.Vector3()).length();
                const boxCenter = box.getCenter(new THREE.Vector3());

                // controls.minDistance = boxSize * 0.1;
                // controls.maxDistance = boxSize * 1.6;
                controls.target.copy(boxCenter);

                frameArea(boxSize * 0.36, boxSize, boxCenter, camera);

                controls.enableZoom = true;
                controls.enableRotate = true;
                // controls.minPolarAngle = 1.1;
                // controls.maxPolarAngle = 1.1;
                controls.panningMode = 1;
                controls.enableDamping = false;
                // controls.dampingFactor = 0.166;

                controls.mouseButtons = {
                    LEFT: THREE.MOUSE.PAN,
                    MIDDLE: THREE.MOUSE.DOLLY,
                    RIGHT: THREE.MOUSE.ROTATE,
                };

                controls.touches = {
                    ONE: THREE.TOUCH.ROTATE,
                    TWO: THREE.TOUCH.DOLLY_PAN,
                };

                var minPan = new THREE.Vector3(-2400, 0, -2800),
                    maxPan = new THREE.Vector3(2600, 1000, 2400),
                    _v = new THREE.Vector3();

                controls.addEventListener("change", () => {

                    _v.copy(controls.target);
                    controls.target.clamp(minPan, maxPan);
                    
                    _v.sub(controls.target);
                    camera.position.sub(_v);
                });
            },

            set_light () {

                console.log('set_light');

                let light;
    
                light = new THREE.HemisphereLight(0xffffff, 0x18515b, 2);
                light.position.set(0, 0, 0);
                scene.add(light);

                light = new THREE.DirectionalLight(0xffffff, 2.5);
                
                /* directionLight 設定陰影 */
                light.castShadow = true;
                light.position.set(40, 30, 6);
                light.target.position.set(0, 0, 0);
                
                scene.add(light);
                scene.add(light.target);
                
                const helper = new THREE.DirectionalLightHelper( light, 9 );
                scene.add( helper );

                light.shadow.mapSize.width = 2048;
                light.shadow.mapSize.height = 2048;


                const d = 60;

                const cam = light.shadow.camera;
                cam.near = 0.1;
                cam.left = -d;
                cam.right = d;
                cam.top = d;
                cam.bottom = -d;
                cam.far = 3000;
                light.shadow.bias = -0.0001;
                light.updateMatrixWorld();
                light.target.updateMatrixWorld();

                window.animate.start(10, this.scene_render);
            },

            

            gltf_get_animation (index, gltf) {

                /* 加入動畫序列 */
                mixer = new THREE.AnimationMixer( gltf.scene );
                mixer.clipAction(gltf.animations[0]).play();
            },


            scene_render () {

                var delta = clock.getDelta();

                mixer.update( delta );

                controls.update();
                renderer.render(scene, camera);
            },

            
        },
    }

    function resizeRendererToDisplaySize(renderer) {

        // console.log('resizeRendererToDisplaySize');
        const canvas = renderer.domElement;
        const width = canvas.clientWidth;
        const height = canvas.clientHeight;
        const needResize = canvas.width !== width || canvas.height !== height;
        if (needResize) renderer.setSize(width, height, false);
        return needResize;
    }

    function frameArea(sizeToFitOnScreen, boxSize, boxCenter, camera) {
        const halfSizeToFitOnScreen = sizeToFitOnScreen * 0.5;
        const halfFovY = THREE.Math.degToRad(camera.fov * .5);
        const distance = halfSizeToFitOnScreen / Math.tan(halfFovY);
        const direction = (new THREE.Vector3())
            .subVectors(camera.position, boxCenter)
            .multiply(new THREE.Vector3(1, 0, 1))
            .normalize();

        camera.position.copy(direction.multiplyScalar(distance).add(boxCenter));
        camera.near = boxSize / 100;
        camera.far = boxSize * 100;

        camera.updateProjectionMatrix();
        camera.lookAt(boxCenter.x, boxCenter.y, boxCenter.z);
    }
</script>

<style lang="scss" scoped>

#main-scene {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: blue;
}

</style>